<form *ngIf="!!get" class="requisition-simplified-filters" name="formRequisitionSimplified" novalidate method="get" role="form" (submit)="$event.preventDefault(); submit.emit()">
    <tt-input ttRememberId="w_requisitionsimplified.requisitiondel_keyno" ttLabel="id" [(ttModel)]="get.requisitiondel_keyno" (ttModelChange)="$event === '' && submit.emit()" ttShowClearButton>
        <tt-form-field-button buttons ttId="search" ttIcon="fas fa-search" ttType="primary" (ttClick)="submit.emit()"></tt-form-field-button>
    </tt-input>
    <tt-input ttRememberId="w_requisitionsimplified.requisitiondel_keyno_from" ttLabel="id_from" [(ttModel)]="get.requisitiondel_keyno_from" (ttModelChange)="$event === '' && submit.emit()" ttShowClearButton>
        <tt-form-field-button buttons ttId="search" ttIcon="fas fa-search" ttType="primary" (ttClick)="submit.emit()"></tt-form-field-button>
    </tt-input>
    <tt-select
        ttRememberId="w_requisitionsimplified.stockplace_id_from"
        ttLabel="stockplace_from"
        [(ttModel)]="get.stockplace_id_from"
        (ttModelChange)="submit.emit()"
        [ttData]="stockplacesFrom"
        ttDataId="stockplace_id_from"
        ttDataName="stockplace_name_from"
    ></tt-select>
    <tt-select
        ttRememberId="w_requisitionsimplified.stockplace_id_to"
        ttLabel="stockplace_to"
        [(ttModel)]="get.stockplace_id_to"
        (ttModelChange)="submit.emit()"
        [ttData]="stockplacesTo"
        ttDataId="stockplace_id_to"
        ttDataName="stockplace_name_to"
    ></tt-select>
    <tt-select
        ttRememberId="w_requisitionsimplified.labour_no"
        ttLabel="packed_off"
        [(ttModel)]="get.labour_no"
        (ttModelChange)="submit.emit()"
        [ttData]="labours"
        ttDataId="labour_no"
        ttDataName="labour_name"
    ></tt-select>
    <tt-select
        ttRememberId="w_requisitionsimplified.status_no"
        ttLabel="status"
        [(ttModel)]="get.status_no"
        (ttModelChange)="submit.emit()"
        [ttData]="statuses"
        ttDataId="requisitiondelstatus_id"
        ttDataName="requisitiondelstatus_name"
    ></tt-select>

    <div class="requisition-simplified-filters__actions">
        <tt-button ttText="send" ttIcon="fas fa-paper-plane" (ttClick)="send()" [ttLoading]="loadingAction === 'send'"></tt-button>
        <tt-button ttText="receive" ttIcon="fas fa-paper-plane fa-flip-horizontal" (ttClick)="receive()" [ttLoading]="loadingAction === 'receive'"></tt-button>
        <tt-button ttText="undo_send" ttIcon="fas fa-undo" (ttClick)="undoSend()" [ttLoading]="loadingAction === 'undo_send'"></tt-button>
        <tt-button ttText="undo_receive" ttIcon="fas fa-redo" (ttClick)="undoReceive()" [ttLoading]="loadingAction === 'undo_receive'"></tt-button>
    </div>
</form>
